import { render, staticRenderFns } from "./BRole.vue?vue&type=template&id=2c134154&scoped=true&"
import script from "./BRole.vue?vue&type=script&lang=js&"
export * from "./BRole.vue?vue&type=script&lang=js&"
import style0 from "./BRole.vue?vue&type=style&index=0&id=2c134154&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c134154",
  null
  
)

export default component.exports